<template>
  <div class="w-100">
    <div class="section-header d-flex">Available Time Slot</div>
    <div class="timeslots px-3 py-2">
      <div v-for="slot in slots" :key="slot.id" class="slot-wrapper mb-3 mt-5">
        <div class="open-slot-card">
          <div class="open-slot-card-body">
            <div class="open-slot-day">{{ slotDay(slot) }}</div>
            <div class="open-slot-month">{{ slotMonth(slot) }}</div>
          </div>
          <div class="open-slot-card-footer">
            <div>{{ slotTime(slot) }}</div>
            <div class="open-slot-footer-resource" v-if="!openSlotDefaultsHideResourceName && getResourceName(slot.resourceId)">with {{ getResourceName(slot.resourceId) }}</div>
            <div class="open-slot-footer-duration" v-if="!openSlotDefaultsHideDuration && slot.durationMinutes">{{ formatDuration(slot.durationMinutes) }}</div>
          </div>
        </div>
        <div class="open-slot-expiry text-danger mt-2" v-if="slotExpiry(slot)">
          <i class="fas fa-hourglass-half"></i> Book before: {{ slotExpiry(slot) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin'
import { DateFormatMixin } from '@/mixins/Booking/DateFormatMixin'
import { OpenSlotDefaultsSettingMixin } from '@/mixins/Booking/OpenSlotDefaultsSettingMixin'
import { formatDuration } from '@/helpers/DurationHelper'
import moment from 'moment-timezone'

export default {
  name: 'OpenSlotList',
  mixins: [DateFormatMixin, TimeFormatMixin, OpenSlotDefaultsSettingMixin],
  props: {
    slots: {
      type: Array,
      default: () => []
    },
    resources: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDuration,
    getResourceName (resourceId) {
      const resource = this.resources.find(r => r.id === resourceId)
      return resource ? resource.name : ''
    },
    slotDay (slot) {
      return moment.utc(slot.startUtc).tz(slot.timeZoneId).format('D')
    },
    slotMonth (slot) {
      return moment.utc(slot.startUtc).tz(slot.timeZoneId).format('MMM')
    },
    slotTime (slot) {
      return moment.utc(slot.startUtc).tz(slot.timeZoneId).format(this.momentJSTimeFormat)
    },
    slotExpiry (slot) {
      if (!slot.expiresUtc) return ''
      const expires = moment.utc(slot.expiresUtc).tz(slot.timeZoneId)
      return `${expires.format(this.momentJSDateFormat)} ${expires.format(this.momentJSTimeFormat)}`
    }
  }
}
</script>

<style scoped>
.timeslots {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
}

.slot-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 0 !important;
}

.open-slot-card {
  border: 2px solid var(--tertiary-color);
  border-radius: 0.75rem;
  overflow: hidden;
  width: 240px;
  display: flex;
  flex-direction: column;
}

.open-slot-card-body {
  padding: 0.6rem 0.75rem 0.5rem;
  color: var(--tertiary-color);
  text-align: center;
  background: #fff;
}

.open-slot-day {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
}

.open-slot-month {
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  margin-top: 0.3rem;
}

.open-slot-card-footer {
  background-color: var(--tertiary-color);
  color: white;
  text-align: center;
  padding: 0.4rem 0.75rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.open-slot-footer-resource {
  font-size: 0.9rem;
  font-weight: 400;
  opacity: 0.9;
  margin-top: 0.2rem;
}

.open-slot-footer-duration {
  font-size: 0.9rem;
  font-weight: 400;
  opacity: 0.9;
  margin-top: 0.2rem;
}

.open-slot-expiry {
  font-size: 0.8rem;
  font-weight: 400;
}
</style>
